import React from 'react'

import history from 'src/config/routes/history'
import { Button, Result } from 'src/components/Ant'

import { WrapLayout } from './styles'

export default function Error404() {
  return (
    <WrapLayout>
      <Result
        extra={
          <Button onClick={() => history.goBack()} title="web.404.action" />
        }
        status="404"
        subTitle="web.404.sub-title"
        title="web.404.title"
      />
    </WrapLayout>
  )
}
